/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenderItemResponseModel } from '../../models/tender-item-response-model';

export interface GetTenderItem$Params {
  tenderId: string;
  itemId: string;
}

export function getTenderItem(http: HttpClient, rootUrl: string, params: GetTenderItem$Params, context?: HttpContext): Observable<StrictHttpResponse<TenderItemResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getTenderItem.PATH, 'get');
  if (params) {
    rb.path('tenderId', params.tenderId, {});
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenderItemResponseModel>;
    })
  );
}

getTenderItem.PATH = '/tenders/{tenderId}/items/{itemId}';
